import React from 'react';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import {
  TechDocsEditPageAddon as techDocsEditPageAddonExtension,
  techdocsEditorPlugin,
} from '@estehsaan/backstage-plugin-techdocs-editor';

// The package exports this addon as a bare `Extension` rather than exposing it
// through its plugin the way `ReportIssue` does. An unexposed extension is not
// a component, and `createReactExtension` only runs its `attachComponentData`
// calls inside `expose`, so the export has to be put through `provide` before
// `useTechDocsAddons` can find it under `TECHDOCS_ADDONS_KEY`.
export const TechDocsEditPageAddon = techdocsEditorPlugin.provide(
  techDocsEditPageAddonExtension,
);

export const TechdocsContent = () => {
  return (
    <EntityTechdocsContent>
      <TechDocsAddons>
        <ReportIssue />
        {/* "Edit this page" in the reader subheader. This replaces a separate
            editor tab on the entity page: the button already knows which file
            is on screen, so it opens the editor on that page instead of the
            doc root. It resolves its target through `editorRouteRef` and
            renders nothing when that ref is unbound, so it depends on the
            `/techdocs-editor/:namespace/:kind/:name` route in the app. */}
        <TechDocsEditPageAddon />
      </TechDocsAddons>
    </EntityTechdocsContent>
  );
};
